import React from 'react';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import mapFacets from 'util/react/facet';

function Sidebar({ facet, viewportHeight, isMobile, headerHeight, children }) {
    return (
        <aside style={{
            transform: isMobile ? null : `translateY(${ headerHeight }px)`,
            height: isMobile ? null : viewportHeight - headerHeight,
        }} className={ classnames('main-sidebar', ...mapFacets(facet, 'main-sidebar')) }>
            { children }
        </aside>
    );
}

Sidebar.propTypes = {
    viewportHeight: PropTypes.number.isRequired,
    headerHeight: PropTypes.number.isRequired,
    isMobile: PropTypes.bool.isRequired,
    facet: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    children: PropTypes.any,
};

export default connect(
    reduxUtils.mapStateToProps({
        isMobile: 'viewport.isMobile',
        viewportHeight: 'viewport.height',
        headerHeight: 'header.height',
    }),
)(Sidebar);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-sidebar/index.js